module.exports = __webpack_public_path__ + "static/media/transfer-FINISHED.e5865739.svg";